import {
	addDays,
	endOfDay,
	startOfDay,
	startOfMonth,
	endOfMonth,
	addMonths,
	startOfWeek,
	endOfWeek,
	startOfYear,
	endOfYear,
	addYears,
	isValid,
	isToday,
	isYesterday,
	format,
} from 'date-fns';
import { UserPermission } from './user.constants';
import { FileType } from './pay.constants';

export enum pagesEnum {
	DASHBOARD = 'dashboard',
	BALANCE = 'balance',
	PAY = 'pay',
	CONVERT = 'convert',
	BENEFICIARY = 'beneficiary',
	ACTIVITY = 'activity',
	REQUEST = 'request',
	REPORT = 'report',
	CONTACT = 'contact',
	SETTINGS = 'settings',
	SWIFT_TRACKING = 'swiftTracking',
	WELCOME = 'welcome',
	PLANS = 'plans',
	PAYMENT = 'payment',
	TERMS = 'terms',
	PRIVACY = 'privacy',
  REFUND = 'refund',
}

const DASHBOARD_BASE = '/';

export type pageType = {
	name: pagesEnum;
	link: string;
	icon: any;
	userPermission: UserPermission[];
};

export const DashboardPages: pageType[] = [
	{
		name: pagesEnum.DASHBOARD,
		link: '/' + pagesEnum.DASHBOARD,
		icon: '/icons/dashboard.svg',
		userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER, UserPermission.VIEWER],
	},
	{
		name: pagesEnum.BALANCE,
		link: DASHBOARD_BASE + pagesEnum.BALANCE,
		icon: '/icons/balance.svg',
		userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER],
	},
	{
		name: pagesEnum.PAY,
		link: DASHBOARD_BASE + pagesEnum.PAY,
		icon: '/icons/wallet.svg',
		userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER],
	},
	{
		name: pagesEnum.CONVERT,
		link: DASHBOARD_BASE + pagesEnum.CONVERT,
		icon: '/icons/refund.svg',
		userPermission: [UserPermission.SIGNER],
	},
	{
		name: pagesEnum.BENEFICIARY,
		link: DASHBOARD_BASE + pagesEnum.BENEFICIARY,
		icon: '/icons/group.svg',
		userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER, UserPermission.VIEWER],
	},
	{
		name: pagesEnum.ACTIVITY,
		link: DASHBOARD_BASE + pagesEnum.ACTIVITY,
		icon: '/icons/task-1.svg',
		userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER, UserPermission.VIEWER],
	},
	{
		name: pagesEnum.REQUEST,
		link: DASHBOARD_BASE + pagesEnum.REQUEST,
		icon: '/icons/analytics-1.svg',
		userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER, UserPermission.VIEWER],
	},
	{
		name: pagesEnum.REPORT,
		link: DASHBOARD_BASE + pagesEnum.REPORT,
		icon: '/icons/task.svg',
		userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER, UserPermission.VIEWER],
	},
	// Contact Form removed because commbox integration was added
	// {
	// 	name: pagesEnum.CONTACT,
	// 	link: DASHBOARD_BASE + pagesEnum.CONTACT,
	// 	icon: '/icons/contact.svg',
	// 	userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER, UserPermission.VIEWER],
	// },
	//   {
	//     name: pagesEnum.SWIFT_TRACKING,
	//     link: DASHBOARD_BASE + pagesEnum.SWIFT_TRACKING,
	//     icon: '/icons/task.svg',
	//   },
	{
		name: pagesEnum.SETTINGS,
		link: DASHBOARD_BASE + pagesEnum.SETTINGS,
		icon: '/icons/gear.svg',
		userPermission: [UserPermission.SIGNER, UserPermission.OPERATIONER, UserPermission.VIEWER],
	},
];

export const FirstTimePages = [
	{
		name: pagesEnum.WELCOME,
		link: '/' + pagesEnum.WELCOME,
		fullLink: '/' + pagesEnum.WELCOME + '/',
		userPermission: [UserPermission.SIGNER],
	},
	{
		name: pagesEnum.PLANS,
		link: '/' + pagesEnum.PLANS,
		fullLink: '/' + pagesEnum.PLANS + '/',
		userPermission: [UserPermission.SIGNER],
	},
	{
		name: pagesEnum.PAYMENT,
		link: '/' + pagesEnum.PAYMENT,
		fullLink: '/' + pagesEnum.PAYMENT + '/',
		userPermission: [UserPermission.SIGNER],
	},
];

export const noBalancePages = [
	pagesEnum.DASHBOARD,
	pagesEnum.BALANCE,
	pagesEnum.BENEFICIARY,
	pagesEnum.ACTIVITY,
	pagesEnum.REQUEST,
	pagesEnum.REPORT,
	pagesEnum.CONTACT,
	pagesEnum.SETTINGS,
];

export interface formValue {
	name: string;
	value: string | number | File | FileType[];
}

export enum userMesaageType {
	ERROR = 'error',
	WARNING = 'warning',
	INFO = 'info',
	SUCCESS = 'success',
}

export type userMessage = {
	exist: boolean;
	type?: userMesaageType;
	text?: string;
	subText?: string | object;
	icon?: any;
};
export const intialMessage: userMessage = {
	exist: false,
};

export enum timing {
	TODAY = 'today',
	YESTERDAY = 'yesterday',
	DATE = 'dd.MM.yyyy',
  DATE_FOR_REPORTS = 'dd-MM-yyyy',
	DATE_FOR_SERVICE = 'yyyy-MM-dd',
	FULLDATE = 'dd.MM.yyyy hh:mm',
	FULLDATEHEBREW = 'dd.MM.yyyy HH:mm',
	TIME = 'hh:mm a',
	MONTH_DAY = 'MMMM d, yyyy',
}
export const getDay = (dateText?: string, formating?: string): string => {
	if (dateText && isValid(new Date(dateText))) {
		if (isToday(new Date(dateText))) {
			return timing.TODAY;
		}
		if (isYesterday(new Date(dateText))) {
			return timing.YESTERDAY;
		} else {
			return format(new Date(dateText), timing.DATE);
		}
	}
	return String(dateText);
};

export const defineds = {
	startOfWeek: startOfWeek(new Date()),
	endOfWeek: endOfWeek(new Date()),
	startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
	endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
	startOfToday: startOfDay(new Date()),
	startOfLastSevenDay: startOfDay(addDays(new Date(), -7)),
	startOfLastThirtyDay: startOfDay(addDays(new Date(), -30)),
	startOfLastNinetyDay: startOfDay(addDays(new Date(), -90)),
	startOfLast365Day: startOfDay(addDays(new Date(), -365)),
	endOfToday: endOfDay(new Date()),
	startOfYesterday: startOfDay(addDays(new Date(), -1)),
	endOfYesterday: endOfDay(addDays(new Date(), -1)),
	startOfMonth: startOfMonth(new Date()),
	endOfMonth: endOfMonth(new Date()),
	startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
	endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
	startOflastYear: startOfYear(addYears(new Date(), -1)),
	endOflastYear: endOfYear(addYears(new Date(), -1)),
};
